import React from "react";

export const StyledIcon = ({
  icon: Icon,
  color
}: {
  icon: React.ElementType;
  color: string;
}) => (
  <div
    className={`p-1 rounded flex items-center justify-center text-white ${color}`}
  >
    <Icon className="w-4 h-4" />
  </div>
);
